import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import { Dimensions, Modal } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styled from 'styled-components/native';
import CloseIcon from '@/assets/icon/close.svg';
import SccRemoteImage from '@/components/SccRemoteImage';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const SCREEN_WIDTH = Dimensions.get('window').width;
const POPUP_HORIZONTAL_PADDING = 24;
const POPUP_WIDTH = SCREEN_WIDTH - POPUP_HORIZONTAL_PADDING * 2;
const BORDER_RADIUS = 12;
export default function HomePopupModal({ popup, visible, onClose, onImageClick, onDismissPermanently, }) {
    const [imageReady, setImageReady] = useState(false);
    return (_jsx(Modal, { visible: visible, transparent: true, animationType: "fade", statusBarTranslucent: true, children: _jsxs(Overlay, { children: [_jsx(BackgroundTouchable, { elementName: "home-popup-overlay-background", onPress: onClose, disableLogging: true }), _jsx(SafeCenter, { edges: ['top', 'bottom'], children: _jsxs(ContentContainer, { style: { opacity: imageReady ? 1 : 0 }, children: [_jsxs(ImageContainer, { children: [_jsx(SccPressable, { elementName: "home-popup-image", onPress: onImageClick, children: _jsx(SccRemoteImage, { imageUrl: popup.imageUrl, style: { width: POPUP_WIDTH }, resizeMode: "contain", wrapperBackgroundColor: null, onReady: () => setImageReady(true), priority: "high" }) }), _jsx(CloseButton, { elementName: "home-popup-close-button", hitSlop: 8, onPress: onClose, children: _jsx(CloseIconWrapper, { children: _jsx(CloseIcon, { width: 12, height: 12, color: color.white }) }) })] }), _jsx(BottomContainer, { children: _jsx(SccPressable, { elementName: "home-popup-do-not-show-again", onPress: onDismissPermanently, children: _jsx(DismissText, { children: "\uB2E4\uC2DC \uBCF4\uC9C0 \uC54A\uAE30" }) }) })] }) })] }) }));
}
// Styled components
const Overlay = styled.View `
  flex: 1;
  background-color: ${color.blacka50};
`;
const SafeCenter = styled(SafeAreaView) `
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const BackgroundTouchable = styled(SccPressable) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
const ContentContainer = styled.View `
  width: ${POPUP_WIDTH}px;
`;
const ImageContainer = styled.View `
  border-top-left-radius: ${BORDER_RADIUS}px;
  border-top-right-radius: ${BORDER_RADIUS}px;
  overflow: hidden;
`;
const CloseButton = styled(SccPressable) `
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background-color: ${color.blacka40};
  justify-content: center;
  align-items: center;
`;
const CloseIconWrapper = styled.View `
  justify-content: center;
  align-items: center;
`;
const BottomContainer = styled.View `
  background-color: ${color.white};
  border-bottom-left-radius: ${BORDER_RADIUS}px;
  border-bottom-right-radius: ${BORDER_RADIUS}px;
  padding-horizontal: 16px;
  padding-vertical: 12px;
`;
const DismissText = styled.Text `
  font-size: 14px;
  font-family: ${font.pretendardRegular};
  color: ${color.gray80};
  text-decoration-line: underline;
`;
